import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { HelpCircle, ChevronDown } from 'lucide-react';

const FAQ_ITEMS = [
  {
    q: 'Comment fonctionne une enchère en direct ?',
    a: 'Le vendeur lance un produit avec un prix de départ et un timer (30 à 90 secondes). Chaque clic sur "Enchérir" fait monter le prix de l\'incrément fixé. Si un bid arrive dans les 10 dernières secondes, le timer se prolonge automatiquement de +10 secondes. Le dernier enchérisseur à la fin du timer remporte le produit.',
  },
  {
    q: 'Comment payer après avoir gagné ?',
    a: 'Vous avez 10 minutes pour payer via Wave ou Orange Money aux coordonnées du vendeur affichées dans votre espace acheteur. Copiez le numéro marchand, effectuez le paiement, puis cliquez sur « J\'ai payé » (la référence du paiement est facultative). Le vendeur confirme, puis marque la commande comme livrée.',
  },
  {
    q: 'Que se passe-t-il si je ne paye pas à temps ?',
    a: 'Sans paiement dans les 10 minutes, votre commande peut être annulée par le vendeur ou l\'équipe. Des pénalités (suspension temporaire du compte) peuvent s\'appliquer en cas de récidive.',
  },
  {
    q: 'Comment devenir vendeur sur JOTALY ?',
    a: 'Créez un compte en choisissant "Vendeur" à l\'inscription. Votre compte sera en attente jusqu\'à validation par l\'équipe (généralement sous 24h). Une fois approuvé, vous pouvez ajouter des produits, lancer un live et démarrer des enchères.',
  },
  {
    q: 'Les vendeurs peuvent-ils diffuser en direct depuis le site ?',
    a: 'Oui. Tous les lives se déroulent directement sur JOTALY avec la caméra de votre téléphone ou ordinateur : créez un live, puis cliquez « Démarrer la diffusion ». Aucune application externe n\'est nécessaire.',
    video: '/guide.mp4',
  },
  {
    q: 'Comment suivre ma boutique favorite ?',
    a: 'Cliquez « Suivre » sur la page d\'une boutique ou dans la salle de live. Vous recevrez une notification push, une alerte dans l\'appli et un e-mail dès que cette vendeuse passe en live. Retrouvez vos favoris dans votre espace acheteuse.',
  },
  {
    q: 'Comment sont protégés les acheteurs ?',
    a: 'Chaque vendeur est vérifié par l\'équipe avant d\'être approuvé. Le chat live est modéré. En cas de litige, un bouton "Relancer vendeur" vous permet d\'alerter, puis l\'équipe admin peut intervenir. Les avis publics aident aussi à identifier les vendeurs de confiance.',
  },
  {
    q: 'Comment noter un vendeur ?',
    a: 'Après réception d\'une commande marquée "Livrée", un bouton "Noter le vendeur" apparaît sur votre espace acheteur. Vous pouvez laisser une note de 1 à 5 étoiles et un commentaire sur la page publique du vendeur.',
  },
  {
    q: 'Puis-je annuler mon compte ?',
    a: 'Oui, écrivez-nous via la page /contact et nous supprimerons votre compte et vos données personnelles dans les 30 jours, conformément à la réglementation.',
  },
];

export default function Faq() {
  const [open, setOpen] = useState(0);
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <div className="flex-1 max-w-4xl mx-auto w-full px-4 sm:px-6 py-12">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-rose-500/10 border border-rose-500/30 text-rose-300 text-xs font-semibold uppercase tracking-widest">
          <HelpCircle className="h-3.5 w-3.5" />FAQ
        </div>
        <h1 className="mt-4 font-display font-extrabold text-4xl sm:text-5xl">Questions fréquentes</h1>
        <p className="mt-3 text-slate-300 max-w-2xl">
          Enchères, paiement, livraison, comptes vendeurs — tout ce qu'il faut savoir pour profiter de JOTALY.
        </p>
        <div className="mt-10 space-y-3">
          {FAQ_ITEMS.map((item, i) => {
            const isOpen = open === i;
            return (
              <div key={i} data-testid={`faq-item-${i}`} className={`card-elev rounded-2xl overflow-hidden transition ${isOpen ? 'border-rose-500/40' : ''}`}>
                <button
                  data-testid={`faq-toggle-${i}`}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full text-left px-5 py-4 flex items-center justify-between gap-4">
                  <span className="font-display font-bold text-base sm:text-lg">{item.q}</span>
                  <ChevronDown className={`h-5 w-5 text-slate-400 transition-transform ${isOpen ? 'rotate-180 text-rose-400' : ''}`} />
                </button>
                <div className={`grid transition-all duration-300 ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                  <div className="overflow-hidden">
                    <div className="px-5 pb-5 text-slate-300 text-sm leading-relaxed">{item.a}
                      {item.video && (
                        <video data-testid={`faq-video-${i}`} controls playsInline preload="metadata" src={item.video} className="mt-4 w-full rounded-xl border border-white/10 aspect-video bg-black" />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <Footer />
    </div>
  );
}
